import * as Plot from "@observablehq/plot";
import { useEffect, useRef } from "react";

/**
 * Enveloppe React autour d'Observable Plot.
 *
 * Plot produit un nœud DOM ; React ne le gère pas. On l'insère à la main et
 * on le retire au démontage, sinon les graphiques s'empilent à chaque rendu.
 */
export default function Graphique({
  options,
}: {
  options: Plot.PlotOptions;
}) {
  const conteneur = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const element = conteneur.current;
    if (!element) return;
    const trace = Plot.plot(options);
    element.append(trace);
    return () => trace.remove();
  }, [options]);

  return <div ref={conteneur} className="graphique" />;
}
